import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { DestroyRef, Directive, EventEmitter, HostListener, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
	selector: '[click.single],[click.double]',
	standalone: true,
})
export class ClickDoubleDirective implements OnInit {

	private readonly destroyRef = inject(DestroyRef)
	private clicksSubject = new Subject<MouseEvent>();

	@Input() clickDebounceTime = 250;
	@Output('click.double') doubleClick = new EventEmitter();
	@Output('click.single') singleClick = new EventEmitter();


	constructor() { }

	ngOnInit() {
		this.clicksSubject.pipe(debounceTime(this.clickDebounceTime))
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(event => {
				if (event.type === 'click') {
					this.singleClick.emit(event);
				} else {
					this.doubleClick.emit(event);
				}
			});
	}


	@HostListener('click', ['$event'])
	clickEvent(event: MouseEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.clicksSubject.next(event);
	}
	@HostListener('dblclick', ['$event'])
	doubleClickEvent(event: MouseEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.clicksSubject.next(event);
	}
} 